<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
    :form-class-name="formClassName"
  >
    <template #label>
      <slot name="label" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #body>
      <input
        class="boss-input"
        :class="numberClassName"
        type="number"
        :value="value"
        :max="maxNumber"
        :min="minNumber"
        :placeholder="placeholder"
        :data-test="dataTest"
        @keypress="keypress"
        @input="update"
      >
      <slot name="suffix" />
    </template>
    <template #error>
      <template v-for="(error, i) in errors">
        <validation-label
          v-if="error.isShow"
          :key="i"
          :data-test="`error-`+i"
          :label="error.message"
        />
      </template>
    </template>
  </form-label>
</template>

<script>
import FormLabel from '@/components/atoms/FormLabel'
import _ from 'lodash'
import ValidationLabel from '@/components/atoms/ValidationLabel'
import eventValidations from '@/lib/eventValidations'

export default {
  components: {
    FormLabel,
    ValidationLabel
  },
  mixins: [eventValidations],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      default: null,
      type: null
    },
    dataTest: {
      type: String,
      default: ''
    },
    errors: {
      type: Array,
      default: () => []
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    formClassName: {
      type: String,
      default: ''
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    minNumber: {
      default: 0,
      type: Number
    },
    maxNumber: {
      default: 0,
      type: Number
    }
  },
  computed: {
    numberClassName () {
      return _.find(this.errors, { isShow: true }) ? this.className + ' is-invalid-input' : this.className
    }
  },
  methods: {
    keypress (e) {
      this.onlyNumberInRange(e, this.maxNumber, this.minNumber)
    },
    update (e) {
      this.$emit('input', e.target.value)
      this.$emit('change', e.target.value)
    }
  }
}
</script>
